import { LOCALES } from "../locales";

export default {
  [LOCALES.SPANISHLATIN]: {
    // general product translation
    January: "enero",
    February: "febrero",
    March: "marzo",
    April: "abril",
    May: "mayo",
    June: "junio",
    July: "julio",
    August: "agosto",
    September: "septiembre",
    October: "octubre",
    November: "noviembre",
    December: "diciembre",
    class_policy: "Condiciones de las sesiones",
    Faq: "Preguntas más frecuentes",
    help: "Ayuda",
    category: "categoría",
    frequently_asked_ques: "Preguntas frecuentes",
    customer_support: "Atención al cliente",
    user_name: "Nombre de usuario",
    password: "Contraseña",
    email_address: "Dirección de correo electrónico",
    // Header Translations
    notification: "Notificación",
    page_loading_aria: "La página se está cargando",
    state_loading_aria: "Cargando estado",
    city_loading_aria: "Cargando ciudad",
    badge_placeholder: "Badge placeholder",
    badge_overall: "Insignia general",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, business english",
    certificate_placeholder: "Imagen del certificado",
    certificate_download: "Botón de descarga del certificado",
    prev: "Anterior",
    log_out: "Cerrar sesión",
    //navbar
    navbar_course: "Curso",
    navbar_tools: "Herramientas",
    navbar_skill_index: "Habilidades",
    navbar_level_index: "Niveles",
    navbar_schedule: "Calendario",
    // feature names
    feature_progress: "Progreso",
    feature_stressAndIntonation_title: "Acentuación y entonación",
    feature_soundOfEnglish_title: "Sonidos del inglés",
    feature_vocabularyCenter_title: "Centro de vocabulario",
    feature_grammarCenter_title: "Centro de gramática",
    feature_culture_centre_title: "Culture center",
    feature_globalCommunityTutorials_title: "Global community tutorials",
    feature_industryfeed_title: "Catálogo de artículos",
    feature_newsfeed_title: "Noticias",
    feature_emailTemplates_title: "Plantillas de correo electrónico",
    feature_talkWithTeacher_title: "Talk with the teacher",
    feature_accentsAndDialects_title: "Acentos y dialectos",
    feature_writingCenter_title: "Centro de redacción",
    feature_toeic_title: "TOEIC",
    feature_toefl_title: "TOEFL",
    // Footer translations
    about: "Sobre",
    legal: "Legal",
    privacy_policy: "Política de privacidad",
    Terms_conditions: "Condiciones De Uso",
    //button translations
    button_continue: "Continuar",
    button_KnowMore: "Saber más",
    button_BuyNow: "Comprar",
    button_Subscribe: "Suscribirse",
    button_GetStarted: "Comenzar",
    button_GetResult: "Tener resultados",
    button_GetLoading: "Loading...",
    button_view: "Ver",
    button_GoText: "Ir",
    button_Resume: "Seguir aprendiendo",
    button_ViewDetails: "Ver detalles",
    button_ContinueStudying: "Continuar",
    button_next: "Siguiente",
    button_confirm: "Confirmar",
    // cookie policy
    common_cookiesPolicyText1:
      "Al continuar usando este sitio web aceptas el uso de cookies para proporcionarte mejores servicios. Saber más sobre nuestra",
    common_cookiesPolicyText2: "política de cookies",
    // EO cookie policy
    //login-page-translations//
    login_welcome: "Te damos la bienvenida,",
    login_heloo: "Hola de nuevo,",
    login_welcome_text: "Comencemos.",
    login_log_in: "Iniciar sesión",
    login_errorIncorrectCreds: "Nombre de usuario o contraseña incorrectos",
    login_errorContactAmin: "Tu cuenta no está activada. Por favor, contacta con tu administrador",
    login_errorSSOuser: "Debes iniciar sesión desde el portal de aprendizaje de tu empresa.",
    login_forgotPassword: "¿Olvidaste tu contraseña?",
    login_resetPasswordTitle: "Restaurar contraseña",
    login_resetSuccess:
      "Te hemos enviado un correo electrónico con un enlace en el que podrás restablecer tu contraseña.",
    login_resetFailure: "La dirección de correo electrónico es incorrecta",
    // common translations
    message_errorDefault: "Algo salió mal",
    message_successUpdated: "Se actualizó correctamente",
    message_unknownError: "Error desconocido",
    message_unAuthorized: "No tienes permiso",
    message_passwordUpdated: "Se actualizó la contraseña correctamente",
    message_profileUpdated: "Se actualizó el perfil correctamente",
    message_welcomeSubmitted: "Enviado correctamente",
    message_samepasswordError: "Introduce una nueva contraseña, asegúrate de que no sea una utilizada previamente.",
    SAR: "Selecciona una región",
    SAL: "Selecciona una ubicación",
    SAT: "Selecciona un tema",
    SAA: "Selecciona un idioma",
    link_readmore: "Leer más",
    // Idle Timer
    session_expiring: "Finalizando sesión",
    timer_title_1: "Tu sesión está a punto de expirar.",
    timer_title_2: "Para continuar aprendiendo, pulsa Aceptar.",
    ok_timer: "Aceptar",
    //--//
    profile_title: "Perfil",
    profile_nameLabel: "Mi nombre es",
    profile_countryLabel: "País",
    profile_stateLabel: "Estado / Provincia / Región",
    profile_cityLabel: "Ciudad",
    profile_emailLabel: "Correo electrónico",
    profile_prefContactLabel: "Método de contacto preferido",
    profile_prefSkypeLabel: "Skype ID (personal) ",
    profile_prefMobileLabel: "Número de celular",
    profile_prefLandlineLabel: "Número fijo",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "Acepto los términos y condiciones",
    profile_continueAria: "Continuar",
    profile_TermsAria: "Aceptar términos y condiciones",
    profile_stateTooltip: "Tu zona horaria nos ayudará a programar tus sesiones.",
    profile_cityTooltip: "Si no vives en ninguna de las ciudades que se  muestran, selecciona la más cercana.",
    profile_emailTooltip: "Verifica tu correo electrónico",
    profile_prefTooltip:
      "Todas las sesiones tendrán lugar en el salón de clases virtual, incluso si seleccionaste un método de contacto diferente en el proceso de incorporación. El método preferido de contacto es solo para uso interno, así podemos mejorar continuamente tu experiencia educativa.",
    profile_fnamePlaceholder: "Nombre",
    profile_lnamePlaceholder: "Apellidos",
    profile_countryPlaceholder: "Selecciona un país",
    profile_prefContactSelect: "Selecciona tu preferencia",
    profile_statePlaceholder: "Selecciona un estado",
    profile_cityPlaceholder: "Selecciona una ciudad",
    profile_emailInvalidMessage: "La dirección de correo electrónico no es válida",
    profile_prefContactPlaceholder: "Elige tu preferencia",
    profile_prefSkypePlaceholder: "Skype (personal)",
    profile_emailVerifiedChip: "Comprobado",
    profile_emailVerifyChip: "Comprobar",
    profile_emailpopup_head: "Introduce el código de verificación",
    profile_emailpopup_codePlaceholder: "Code",
    profile_emailpopup_resendText: "Reenviar código",
    profile_emailpopup_resendMessage: "¿No recibiste ningún código?",
    profile_invalidNumber: "Número no válido",
    profile_prefSkypeAria: "Modo de contacto preferido, Skype ID (personal)",
    profile_prefMobileAria: "Modo de contacto preferido, celular",
    profile_prefLandlineAria: "Modo de contacto preferido, teléfono fijo",
    profile_emailpopup_incorrectCode: "Código no válido",
    profile_editLabel: "Editar perfil",
    profile_editAria: "Editar",
    profile_mainPasswordPlaceholder: "Introducir contraseña aquí",
    profile_updateLabel: "Actualizar",
    profile_welcomeJumbotron: "Háblanos de ti",
    profile_cancelLabel: "Cancelar",
    noAccessl1: "¡Vaya! No tienes permiso para ver esta página.",
    noAccessl2: "Pulsa en este enlace para volver",
    noAccessl2_1: "a la página de inicio.",
    noAccessl3: "Contacta con tu administrador de Learnship para obtener ayuda.",
    license_information: "Mi licencia",
    profile_license_information: "Información de licencia",
    profile_license_message: "Su licencia vence el",
    profile_changepass_changepassHead: "Cambiar contraseña",
    profile_changepass_currentpassword: "Contraseña actual",
    profile_changepass_currentpasswordPlaceholder: "Introducir contraseña actual",
    profile_changepass_newpassword: "Nueva contraseña",
    profile_changepass_newpasswordPlaceholder: "Introducir nueva contraseña",
    profile_changepass_confirmnewpassword: "Confirmar nueva contraseña",
    profile_passMustInclude: "Tu contraseña debe incluir:",
    profile_passdontmatch: "Las contraseñas no coinciden",
    profile_incorrectPassword: "Contraseña incorrecta",
    profile_passwordSubmit_title: "Introducir contraseña",
    profile_changepass_conditionLength: "Debe contener entre 8 y 32 caracteres.",
    profile_changepass_conditionUppercase: "Al menos una letra mayúscula.",
    profile_changepass_conditionLowercase: "Al menos una letra minúscula.",
    profile_changepass_conditionSpecialCharacters: "Al menos un dígito numérico y uno de estos símbolos $!#&@?%*_",
    profile_translationLanguage: "Preferencia de idioma",
    profile_translationLanguagePlaceholder: "Selecciona un idioma",
    profile_managerEmailPlaceholder: "Correo electrónico del manager",
    profile_managerEmailpopupPlaceholder: "Dirección de correo electrónico del manager",
    // Learner Home Page translations
    learnerhome_survey_header: "¡Tu opinión nos interesa!",
    learnerhome_survey_line1: "Tu compañía quiere conocer tu experiencia usando nuestros servicios.",
    learnerhome_survey_line2: "Completa la encuesta antes del",
    learnerhome_survey_line3: "Tu opinión es muy importante para nosotros.",
    learnerhome_survey_button1: "Hacer encuesta",
    learnerhome_survey_button2: "Saltar encuesta",
    active_course: "Curso activo",
    admin_header: "Administración",
    admin_dashboard_header: "Dashboard",
    get_startedText: "Pulsa en un curso para comenzar.",
    product_solo_desc:
      "Learnship Solo, nuestro servicio de e-learning, ofrece todo lo que necesitas para practicar y mejorar tus habilidades a tu propio ritmo.",
    product_conversationPractice_desc:
      "Podrás tener sesiones individuales con un profesor para hacer preguntas, hablar de problemas particulares o practicar la conversación con ejemplos de situaciones reales. Útil para aquellos estudiantes corporativos con mayor nivel que buscan mejorar sus habilidades.",
    product_sprint_businessSkills_desc:
      "Este programa de aprendizaje blended de última generación te ayudará a desarrollar habilidades de negocios específicas, presentaciones, negociaciones, redacción y participación en reuniones, en tiempo récord.",
    product_sprint_levelsProgress_desc:
      "Gracias a nuestro método de aprendizaje blended de última generación los estudiantes corporativos mejorarán sus habilidades en un idioma extranjero dentro de un marco estandarizado de manera rápida.",
    product_sprint_business_german_desc:
      "Nuestro método de aprendizaje blended de nueva generación ayuda a tus empleados a mejorar sus habilidades de alemán dentro de un marco estandarizado de manera rápida.",
    product_sprint_business_french_desc:
      "Nuestro método de aprendizaje blended de nueva generación ayuda a tus empleados a mejorar sus habilidades de francés dentro de un marco estandarizado de manera rápida.",
    product_sprint_business_spanish_desc:
      "Nuestro método de aprendizaje blended de nueva generación ayuda a tus empleados a mejorar sus habilidades de español dentro de un marco estandarizado de manera rápida.",
    product_sprint_business_skills_groups_desc:
      "This next-generation blended learning program helps learners develop specific business skills— in groups—in record time.",
    product_evolve_relocationLanguage_desc:
      "Con nuestro programa de reubicación de empleados desarrollarán una mayor comprensión del idioma y los aspectos sociales de su nuevo país de residencia.",
    product_evolve_culturePowerSkills_desc:
      "Los estudiantes corporativos obtendrán habilidades interculturales esenciales para prosperar en entornos de trabajo internacionales y equipos globales virtuales.",
    product_evolve_cultureFocus_desc:
      "Ofrecemos también capacitación específica centrada en el país e inteligencia cultural que ayudará a comprender mejor la cultura de trabajo del nuevo país de destino.",
    product_evolve_cultureChange_desc:
      "Este es nuestro principal programa de capacitación para empresas en comunicación intercultural para empleados expatriados. Proporciona una visión completa de lo que significa vivir y trabajar en una nueva cultura.",
    product_elevate_businessSkills_desc:
      "Módulos de capacitación cortos y estandarizados para mejorar habilidades específicas como presentaciones en público, negociaciones o liderazgo de equipo. También ofrecemos cursos especiales enfocados en terminología específica.",
    product_elevate_levelsProgress_desc:
      "Este curso de idiomas para empresas dirigido por un profesor contribuye a la mejora de la comprensión y expresión escrita y oral dentro de un marco estandarizado.",
    product_coach_languageCoach_desc:
      "Comunícate de manera clara y segura en conferencias, correos electrónicos, negociaciones o simplemente conversando con tus compañeros. El coaching individual y específico para ejecutivos en idiomas te ayuda a dominar los escenarios de negocios más importantes. Desarrolla tus habilidades de comunicación orales y escritas.",
    product_coach_cultureCoach_desc:
      "Programa de coaching individual, para ejecutivos que buscan solucionar problemas específicos de comunicación intercultural.",
    product_solo_business_english:
      "Programa de aprendizaje multinivel con ejercicios online para desarrollar tu conocimiento y aplicación del inglés de negocios a tu propio ritmo.",
    product_solo_business_german:
      "Programa de aprendizaje multinivel con ejercicios online para desarrollar tu conocimiento y aplicación del alemán de negocios a tu propio ritmo.",
    product_solo_business_french:
      "Programa de aprendizaje multinivel con ejercicios online para desarrollar tu conocimiento y aplicación del francés de negocios a tu propio ritmo.",
    product_solo_business_spanish:
      "Programa de aprendizaje multinivel con ejercicios online para desarrollar tu conocimiento y aplicación del español de negocios a tu propio ritmo.",
    product_lorem_desc: "Lorem Ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc:
      "Esta es tu puerta de entrada a Dashboard, una interfaz intuitiva que permite a los administradores hacer un seguimiento del uso, analizar el progreso de los alumnos, optimizar los programas y evaluar el ROI.",
    product_elevate_desc:
      "Elevate Business English es nuestro programa de capacitación online individual para estudiantes corporativos que quieren mejorar su nivel general de inglés con un profesor particular.",
    product_reach_desc:
      "Enhance your learning journey with personalized micro-modules and side missions focusing on real-world business skills.",
    product_lorem_solo_desc:
      "Este programa multimedia ayuda a tus empleados a mejorar rápidamente sus habilidades lingüísticas en inglés dentro de un marco estandarizado.",
    //feature translations
    feature_cultureCentre_desc:
      "Familiarízate con las culturas de las regiones relevantes para tus negocios y vida profesional.",
    feature_emailTemplates_desc:
      "Las plantillas de correo electrónico cubren una amplia variedad de temas de negocios. Selecciona la plantilla que quieres y expórtala directamente a tu correo, donde podrás editarla.",
    feature_newsFeed_desc:
      "¡Te damos la bienvenida a nuestra revolucionaria experiencia de actualidad mundial! Mejora tu inglés gracias al contenido y las preguntas generadas de manera automática.",
    feature_talkWithTeacher_desc:
      "Para estudiantes corporativos que quieren poner en práctica las habilidades lingüísticas adquiridas. Podrán unirse a un grupo en el salón de clases virtual para practicar el idioma de su elección y participar en sesiones de preguntas y respuestas con especialistas.",
    feature_industryFeed_desc:
      "Nuestro catálogo de artículos combina una biblioteca de contenido específico de cada industria con ejercicios generados por inteligencia artificial. Elige un artículo y un tema de gramática que te interese practicar.",
    feature_accentsAndDialects_desc:
      "Descubre cómo suena el inglés alrededor del mundo con nuestra biblioteca de muestras de habla regional.",
    feature_stressAndIntonation_desc:
      "Haz que tu inglés suene más natural y sea fácil de entender aprendiendo a utilizar la acentuación, ritmo y entonación correctos cuando hablas.",
    feature_soundOfEnglish_desc:
      "Mejora tus habilidades comunicativas aprendiendo a pronunciar los sonidos del inglés correctamente.",
    feature_vocabularyCenter_desc: "Sin gramática poco se puede comunicar, sin vocabulario nada – David Wilkins",
    feature_grammarCenter_desc:
      "El Centro de Gramática te ayudará a emplear la gramática correcta en tu expresión oral y escrita. Se incluyen también temas de gramática, como las partes básicas de una oración, verbos, formas verbales, oraciones subordinadas y locuciones.",
    feature_globalCommunityTutorials_desc:
      "Mejora tus habilidades de inglés con esta colección de lecciones desarrolladas por la comunidad.",
    feature_toeic_desc:
      "El examen TOEIC® es una de las herramientas más usadas en empresas multinacionales para determinar el nivel de inglés de sus empleados. TOEIC® emplea material escrito y diálogos auténticos para evaluar el nivel de inglés de negocios.",
    feature_toefl_desc:
      "TOEFL®, del inglés Test of English as a Foreign Language (prueba de inglés como lengua extranjera), se emplea en universidades, agencias gubernamentales y programas de becas de todo el mundo para evaluar el nivel de inglés.",
    feature_businessSituations_desc:
      "El Business Situations Index (índice de situaciones de negocios) facilita la búsqueda de actividades específicas para que puedas centrarte en el idioma y expresarte en una variedad de situaciones de negocios.",
    //carousel block translations
    title_feature: "Herramientas",
    we_recommend: "También recomendamos",
    // session report translations
    SessionReport_sessionReport: "Informe de la sesión",
    SessionReport_sessionDetails: "Detalles",
    SessionReport_teacherName: "Nombre del profesor",
    SessionReport_sessionReview: "Evaluación de la sesión",
    SessionReport_sessionFeedback: "Feedback de la sesión",
    SessionReport_sessionMaterials_Assignments: "Materiales de la sesión y tareas",
    SessionReport_instructions: "Instrucciones",
    SessionReport_open: "Abrir",
    SessionReport_invalidSession_Message: "Lo sentimos, esta sesión no contiene ningún informe.",
    SessionReport_rateSession: "Puntúa tu sesión",
    SessionReport_handouts: "Descargables",
    SessionReport_coachName: "¿Cómo fue tu sesión con",
    SessionRating_sessionDate: "Fecha de la sesión",
    SessionRating_sessionTime: "Hora de la sesión",
    SessionRating_sessionDuration: "Duración de la sesión",
    SessionRating_status: "Estado",
    SessionRating_rateYourExperience: "Puntúa tu experiencia",
    SessionRating_whatWentWrong: "¿Qué salió mal?",
    SessionRating_content: "Contenido",
    SessionRating_technology: "Tecnología",
    SessionRating_comment: "Deja un comentario",
    SessionRating_submit: "Enviar",
    SessionRating_remindMeLater: "Recordarme más tarde",
    SessionRating_close: "Cerrar",
    SessionRating_completed: "Completadas",
    sessionRating_sessionDetails_mins: "Minutos",
    // my schedule page translations
    myschedule_availability_abty_given: "Estamos trabajando para encontrar el mejor profesor para ti.",
    myschedule_schedule: "Mi horario",
    myschedule_availability_needAvl: "Necesitamos tu disponibilidad para programar tu sesión",
    myschedule_availability_abty_not_given: "Indica / Modifica tu disponibilidad",
    myschedule_statusCard_completed: "Sesiones completadas",
    myschedule_statusCard_remaining: "Sesiones restantes",
    myschedule_statusCard_scheduled: "Sesiones por programar",
    myschedule_statusCard_lost: "Sesiones perdidas (cancelación tardía y ausencias)",
    myschedule_recentUpcoming_courseName: "Nombre del curso",
    myschedule_next_session: "Próxima sesión",
    myschedule_session_topic: "Tema de la sesión",
    myschedule_sessionDetails_communication: "Comunicación",
    myschedule_sessionDetails_allSessions: "Todas las sesiones",
    myschedule_sessionDetails_upcomingSessions: "Próximas sesiones",
    myschedule_sessionDetails_completedSessions: "Sesiones completadas",
    myschedule_sessionDetails_missedSessions: "Sesiones perdidas",
    myschedule_sessionDetails_teacher_name: "Profesor",
    myschedule_sessionDetails_sessions: "Número",
    myschedule_sessionDetails_date: "Fecha",
    myschedule_sessionDetails_time: "Hora",
    myschedule_sessionDetails_durationText: "Duración",
    myschedule_sessionDetails_min: "Min.",
    myschedule_reschedule_Title: "Cómo reprogramar una sesión",
    myschedule_reschedule_InstrBegin: "Cómo reprogramar sesiones con tu profesor",
    myschedule_reschedule_instr1a: "Ver detalles de la sesión en la parte superior",
    myschedule_reschedule_instr1b: "La fecha y hora de cada sesión se muestran en la parte superior de la pantalla.",
    myschedule_reschedule_instr2: "La disponibilidad del profesor se muestra en verde",
    myschedule_reschedule_instr3:
      "Podrás ver la disponibilidad de tu profesor. Las horas disponibles se muestran en verde.",
    myschedule_reschedule_instr4: "Selecciona un espacio para reprogramar tu sesión",
    myschedule_reschedule_instr5:
      "Para reprogramar una sesión, haz clic en el área verde de los espacios de horario disponibles",
    myschedule_reschedule_next_instr1: "No encuentro la hora adecuada",
    myschedule_reschedule_next_instr2:
      "Intenta evitar las cancelaciones, si no encuentras una hora adecuada con tu profesor, pulsa sobre “No encuentro la hora adecuada” para cancelar tu sesión. En este caso, tu profesor programará la sesión por ti o un administrador te ayudará.",
    myschedule_reschedule_next_instr3: "Cambiar de profesor",
    myschedule_reschedule_next_instr4a: "Para cambiar de profesor para una o más sesiones, utiliza nuestro",
    myschedule_reschedule_next_instr4b: "formulario de contacto,",
    myschedule_reschedule_next_instr4c:
      "y selecciona {productname} + Cambiar Profesor. Indica el motivo por el que te gustaría cambiar de profesor.",
    myschedule_rechedule_next_info: "Para más información sobre la cancelación y el cambio de sesiones, visita nuestro",
    myschedule_rechedule_next_faq: "portal de preguntas frecuentes",
    myschedule_rechedule_next_noShow: "No volver a mostrar esta página",
    myschedule_rechedule_next_done: "Listo",
    myschedule_rechedule_skipButton: "Saltar",
    myschedule_upcoming_joinNow: "Participar ahora",
    myschedule_cancel_question: "¿Seguro que quieres cancelar esta sesión?",
    myschedule_cancel_button: "Cancelar sesión",
    myschedule_cancel_no: "No",
    myschedule_invalid_session: "Lo sentimos, esta sesión no es válida",
    myschedule_sessionDuraion_minutes: "Minutos",
    myschedule_homepage_view: "Ver",
    myschedule_finished_status: "Completadas",
    myschedule_reschedule_button: "Reprogramar",
    myschedule_addToCalendar_instr1: "Pulsa en el",
    myschedule_addToCalendar_instr2:
      "botón de descarga para obtener tu horario con Learnship. Así podrás incorporarlo a tu calendario personal.",
    myschedule_addToCalendar_instr3:
      "Si has añadido un horario de Learnship con anterioridad, asegúrate de eliminarlo antes.",
    myschedule_addToCalendar_instr4: "Saber más sobre cómo incorporar tu horario de Learnship a tu calendario personal",
    myschedule_addToCalendar_instr5: "aquí",
    myschedule_no_teacher_title: "No tienes un profesor asignado",
    myschedule_no_teacher_body:
      "No se pueden añadir sesiones en este momento (No hay profesores asignados). Por favor, contacta con coach@globalenglish.com para continuar con tu programa.",
    myschedule_no_all_sessions: "No se encontraron sesiones",
    myschedule_no_upcoming_sessions: "No se encontraron próximas sesiones",
    myschedule_no_missed_sessions: "No se encontraron sesiones perdidas",
    myschedule_no_completed_sessions: "No se encontraron sesiones completadas",
    myschedule_status_lost: "Perdidas",
    myschedule_status_finished: "Finalizadas",
    myschedule_status_completed: "Completadas",
    myschedule_status_cancelled: "Canceladas",
    myschedule_status_inprogress: "En curso",
    myschedule_status_pending: "Pendientes",
    myschedule_status_active: "Activas",
    myschedule_status_inplanning: "Planificadas",

    // my schedule page translations end

    // Progress page
    progress_title: "Mi progreso",
    progress_activity_report: "Informe de actividad",
    progress_test_results: "Resultados de la prueba",
    progress_productname_sprint_skills: "Sprint Business Skills",
    progress_productname_reach_skills: "Habilidades de Reach",
    progress_skill_note:
      "Debes completar al menos el 70 % de tu curso y las sesiones para conseguir un certificado de finalización.",
    progress_overall_card_title_prework: "Trabajo previo completado",
    progress_overall_card_title_homework: "Tarea completada",
    progress_overall_card_title_session: "Sesiones completadas",
    progress_overall_card_title_certificate: "Certificado",
    progress_overall_card_title_skillsCompleted: "Habilidades completadas",
    progress_overall_card_title_badgesEarned: "Medallas ganadas",
    progress_overall_card_title_missionsPassed: "Misiones aprobadas",
    progress_overall_card_title_timeInReach: "Tiempo en Reach (HH:MM)",
    progress_noSubskill: "No hay ninguna subhabilidad para mostrar.",
    progress_tab_nodata: "No hay datos para mostrar.",
    progress_tab_notonboarded: "Complete su incorporación para acceder a sus informes",
    progress_activityreport_nodata: "Actualmente, no hay datos para mostrar aquí. Sigue aprendiendo y vuelve más tarde",
    progress_percentCompleted: "% completado",
    progress_subskill_preworkTitle: "Trabajo previo",
    progress_subskill_homeworkTitle: "Tareas",
    progress_subskill_sessionTitle: "Sesión",
    progress_subskill_sessionStatusCompleted: "Completada",
    progress_subskill_sessionStatusNotCompleted: "No completada",
    progress_subskill_sessionStatusNoSessions: "No hay sesiones",
    progress_subskill_sessionStatusAbsent: "Ausente",
    progress_subskill_sessionNoDate: "N/A",
    progress_activity_tooltip_totaltime: "Tiempo total",
    progress_activity_tooltip_activitiesCompleted: "Actividades completadas",
    progress_activity_tooltip_reachMissionsCompleted: "Misiones de Reach completadas",
    progress_activity_tooltip_timeinhhmm: "Hora en HH:MM",
    progress_activity_tabDaily: "Diario",
    progress_activity_tabWeekly: "Semanal",
    progress_activity_tabMonthly: "Mensual",
    progress_activity_tabQuarterly: "Trimestral",
    progress_activity_tabQuarter: "Trimestre",
    progress_activity_tabYearly: "Anual",
    progress_acitivity_Minutes: "Minutos",
    progress_acitivity_legend_selfpaced: "Tiempo de aprendizaje autoguiado",
    progress_acitivity_legend_trainerLed: "Tiempo de aprendizaje con profesor",
    progress_acitivity_legend_recommended: "Recomendado",
    progress_testresults_table_testname: "Nombre de la prueba",
    progress_testresults_table_scores: "Puntuaciones",
    progress_testresults_table_date: "Fecha",
    progress_testresults_placed_text: "Placed",
    progress_test_result_timer_text: "*Your test results will appear in 24 hours.",
    progress_testresults_info: "Los resultados de la prueba estarán disponibles en 24 horas.",
    progress_inprogress: "En curso",
    progress_totalscore: "Calificación total",
    progress_placedText: "Resultado",
    progress_button_viewscore: "Ver informe detallado",
    progress_certificate_download_success: "Se descargó correctamente",
    progress_partText: "Parte",
    progress_emptyPartText: "Otro",
    progress_overall_card_title_badge: "Medalla",
    progress_total_correctness_percentage: "Your success score is: ",
    progress_badge_dialog_box_title:
      "Para conseguir un certificado de finalización, tendrás que completar el 70 % de los ejercicios digitales.",
    progress_badge_dialog_box_golden: "Con una calificación del 80 %, obtendrás una insignia de oro",
    progress_badge_dialog_box_silver: "Con una calificación entre el 70 % y el 79 %, obtendrás una insignia de plata",
    progress_badge_dialog_box_bronze: "Con una calificación entre el 50 % y el 69 %, obtendrás una insignia de bronce",
    progerss_badge_dailog_box_digitalActivities:
      "La calificación total se calcula en función de tu rendimiento y participación en las actividades digitales",
    progress_badge_dailog_box_liveSessions:
      "La calificación total se calcula en función de tu rendimiento y participación en las sesiones en vivo y las actividades digitales",
    progress_elevate_dialog_box_liveSessions:
      "The success score is calculated based on your performance and engagement with live sessions",
    //EO Progress page
    //Email templates
    languageSelect: "Select a language",
    wcGroup1: "Disculpas",
    wcGroup2: "Reclamos",
    wcGroup3: "Cumplidos",
    wcGroup4: "Felicitaciones",
    wcGroup5: "Documentos",
    wcGroup6: "Invitaciones",
    wcGroup7: "Solicitudes de empleo",
    wcGroup8: "Marketing y Ventas",
    wcGroup9: "Reuniones",
    wcGroup10: "Avisos",
    wcGroup11: "Pedidos",
    wcGroup12: "Información de precios",
    wcGroup13: "Solicitudes",
    wcGroup14: "Agradecimiento",
    wcTitle11: "Disculpas por un retraso en un proyecto",
    wcTitle12: "Disculpas por un error de contaduría",
    wcTitle13: "Disculpas por un envío tardío",
    wcTitle14: "Disculpas por entrega de bienes dañados",
    wcTitle15: "Disculpas por faltar a una reunión",
    wcTitle21: "Reclamo general",
    wcTitle22: "Reclamo sobre un problema con un producto",
    wcTitle23: "Reclamo sobre un sobrecargo a una cuenta",
    wcTitle31: "Cumplido a un colega sobre un proyecto",
    wcTitle32: "Cumplido sobre servicio al cliente",
    wcTitle33: "Cumplido sobre un producto",
    wcTitle41: "Felicitaciones por un ascenso (formal)",
    wcTitle42: "Felicitaciones por un ascenso (informal)",
    wcTitle43: "Felicitaciones por un evento personal",
    wcTitle51: "Documento solicitado",
    wcTitle52: "Formulario de pedido u orden de compra",
    wcTitle53: "Factura",
    wcTitle61: "Invitación a un evento social",
    wcTitle62: "Invitación a un evento de negocios",
    wcTitle63: "Cómo aceptar una invitación",
    wcTitle64: "Cómo rechazar una invitación",
    wcTitle65: "Cómo cancelar un evento empresarial",
    wcTitle71: "Acuse de recibo de una solicitud",
    wcTitle81: "Anuncio de un nuevo producto",
    wcTitle82: "Anuncio de un nuevo representante de área",
    wcTitle83: "Demostración de un nuevo producto",
    wcTitle84: "Cambio de dirección de facturación",
    wcTitle85: "Contacto después de una primera reunión de Ventas",
    wcTitle86: "Bienvenida a un nuevo cliente",
    wcTitle87: "Felicitación de fiestas a accionistas o clientes",
    wcTitle91: "Cómo proponer una hora para una reunión",
    wcTitle92: "Cómo confirmar una reunión",
    wcTitle93: "Cómo posponer una reunión",
    wcTitle94: "Cómo cancelar una reunión",
    wcTitle95: "Cómo resumir una reunión",
    wcTitle101: "Cuenta suspendida",
    wcTitle102: "Solicitud para cerrar una cuenta",
    wcTitle111: "Cómo confirmar un pedido",
    wcTitle112: "Cómo entregar una confirmación de envío",
    wcTitle113: "Cómo cancelar un pedido",
    wcTitle114: "Cómo cambiar un pedido",
    wcTitle115: "Cómo acusar recibo de una entrega",
    wcTitle121: "Cómo proporcionar información de precios",
    wcTitle122: "Cómo aceptar una cotización de precios",
    wcTitle123: "Cómo rechazar una cotización de precios",
    wcTitle131: "Solicitud de clarificación de información",
    wcTitle132: "Solicitud de información sobre un producto",
    wcTitle133: "Solicitud de información sobre un servicio",
    wcTitle141: "Agradecimiento general",
    Blob: "Las plantillas de correo electrónico abarcan una amplia variedad de temas empresariales. Selecciona la plantilla que desees y expórtala directamente a tu correo electrónico para editarla.",
    OpenInEmail: "Abrir en mi correo electrónico",
    Quote1: "Actualmente hay 3.300 millones de cuentas de correo electrónico en todo el mundo.",
    Quote1By: "Mashable",
    Quote2: "El correo electrónico duplica la tasa de retorno, en comparación con otros canales de comunicación.",
    Quote2By: "Director de Marketing directo",
    Quote3: "Cada segundo se envían 3,5 millones de correos electrónicos.",
    Quote3By: "Director de Marketing",
    SelectACategory: "Selecciona una categoría",
    Title: "Plantillas de correo electrónico",
    WatchTutorial: "Ver un tutorial en video",
    String: "Quote1",
    //Culture Notes Dropdowns
    NoAm: "Norteamérica",
    Cenam: "Centroamérica",
    SoAm: "Sudamérica",
    EUR: "Europa",
    ASIA: "Asia",
    CenASIA: "Asia Central",
    SoEASIA: "Sudeste Asiático",
    MidEAST: "Oriente Medio",
    AFR: "África",
    AUST: "Australia",
    Cana: "Canadá",
    Mexi: "México",
    Uniteds: "Estados Unidos",
    CostaR: "Costa Rica",
    DomRep: "República Dominicana",
    Guate: "Guatemala",
    Jama: "Jamaica",
    Panam: "Panamá",
    TriniTob: "Trinidad y Tobago",
    Arge: "Argentina",
    Braz: "Brasil",
    Chil: "Chile",
    Vene: "Venezuela",
    Colomb: "Colombia",
    Peru: "Perú",
    Urug: "Uruguay",
    Austria: "Austria",
    Belg: "Bélgica",
    Bulg: "Bulgaria",
    Croatia: "Croacia",
    Czec: "República Checa",
    Denm: "Dinamarca",
    Finl: "Finlandia",
    Fran: "Francia",
    Germ: "Alemania",
    Greec: "Grecia",
    Hung: "Hungría",
    Icel: "Islandia",
    Irel: "Irlanda",
    Ital: "Italia",
    Lith: "Lituania",
    Luxem: "Luxemburgo",
    Neth: "Países Bajos",
    Norw: "Noruega",
    Pola: "Polonia",
    Port: "Portugal",
    Roma: "Rumanía",
    Russ: "Rusia",
    Serb: "Serbia",
    Slovakia: "Eslovaquia",
    Slovania: "Eslovenia",
    Spai: "España",
    Swed: "Suecia",
    Swit: "Suiza",
    Turk: "Turquía",
    Ukra: "Ucrania",
    Unitedk: "Reino Unido",
    Chin: "China",
    Hong: "Hong Kong",
    Indi: "India",
    Japa: "Japón",
    Mongo: "Mongolia",
    Pakis: "Paquistán",
    SoKore: "Corea del Sur",
    SriLan: "Sri Lanka",
    Taiw: "Taiwán",
    Afgh: "Afganistán",
    Azer: "Azerbaiyán",
    Kaza: "Kazajistán",
    Camb: "Camboya",
    Indo: "Indonesia",
    Malay: "Malasia",
    Phil: "Filipinas",
    Sing: "Singapur",
    Thai: "Tailandia",
    Viet: "Vietnam",
    Bah: "Baréin",
    Iran: "Irán",
    Iraq: "Iraq",
    Isra: "Israel",
    Jor: "Jordania",
    Kuw: "Kuwait",
    Leb: "Líbano",
    Oma: "Omán",
    Qat: "Qatar",
    SauArb: "Arabia Saudí",
    UAE: "Emiratos Árabes Unidos",
    Alger: "Algeria",
    Angol: "Angola",
    Egyp: "Egipto",
    Ghana: "Ghana",
    Guin: "Guinea",
    Keny: "Kenia",
    Malaw: "Malaui",
    Moroc: "Marruecos",
    Mozam: "Mozambique",
    Nige: "Nigeria",
    SoAfr: "Sudáfrica",
    Tanz: "Tanzania",
    Ugan: "Uganda",
    Zamb: "Zambia",
    Austra: "Australia",
    NewZea: "Nueva Zelanda",
    //Culture Notes Dropdowns End
    culturenotes_mainintrotext:
      "Familiarízate con las culturas de las regiones relevantes para tu empresa y vida profesional.",
    culturenotes_useculturalinfo:
      "Consulta la información cultural que ofrecemos para preparar reuniones con clientes y compañeros de distintos países.",
    culturenotes_topicfamiliarize:
      "Familiarízate con las costumbres de otras culturas, como horarios laborales, cenas fuera de casa, regalos, entre otras.",
    culturenotes_topiclearnculture:
      "Aprende sobre otras prácticas y diferencias culturales, así como las formas correctas de comportarse en cada lugar, para evitar cometer errores culturales.",
    culturenotes_tmaworldtext:
      "Los informes sobre cada país son elaborados por nuestro socio TMA World, y están disponibles para su descarga en PDF.",
    culturenoteslocation_viewbytopic: "Ver por tema",
    culturenoteslocation_viewbycountry: "Ver por país",
    culurecenter_disclaimer_title: "Descargo de responsabilidad",
    culturecenter_disclaimer:
      "No olvides que la información acá contenida es una guía general, que pretende ser un punto de partida para familiarizarte con una nueva cultura. Te ayudará a conocer los patrones culturales comunes, que te servirán de referencia para comprender e interpretar mejor las diferencias culturales en el comportamiento, las actitudes o las reacciones de las personas. Sin embargo, es importante tener en cuenta que las características comunes de una determinada cultura varían según la región y la personalidad de cada persona.",
    culturecenter_intercept_title: "¡El Centro cultural está de vuelta!​​",
    culturecenter_intercept_text1:
      "Tras unos cuantos retoques, nos alegra anunciar la vuelta de nuestro Centro cultural.",
    culturecenter_intercept_text2:
      "Con el Centro cultural podrás descubrir las costumbres y prácticas profesionales de más de 20 países de todos los rincones del mundo, como Estados Unidos, Canadá, México, China, Japón, India... ¡y muchos más!",
    culturecenter_intercept_direct: "Ir a centro cultural​",
    dailyNewsFeed_resources: "Recursos",
    dailyNewsFeed_daily_News: "News Feed diario",
    dailyNewsFeed_newsfeedoftheday: "News Feed del día",
    dailyNewsFeed_feedcontent:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData: "Lo sentimos, no podemos mostrar News Feed, vuelve a intentarlo más tarde",
    dailyNewsFeed_viewMoreCategories: "Ver más",
    // Email templates end
    //Error Page Translations
    error_not_found: "¡Vaya! no se encuentra la página.",
    error_contact_csm: "Pide ayuda a tu manager de customer success.",
    error_under: "En",
    error_maintenance: "mantenimiento",
    error_under_maintenance: "La página está actualmente en mantenimiento programado.",
    error_inconvenience: "Lamentamos las molestias.",
    error_tryagain: "Vuelve a intentarlo más tarde.",
    error_tryagainMins: "Vuelve a intentarlo en",
    error_minutes: "minuto(s)",
    error_hours: "hora(s)",
    error_oops: "¡Vaya!",
    error_permission_denied: "No tienes permiso para ver esta página.",
    error_link_home: "página de inicio",
    error_contact_admin: "Contacta con tu administrador de Learnship para pedir ayuda.",
    error_sorry: "Lo sentimos.",
    error_load: "Hubo un problema al cargar la página.",
    error_clear_cache:
      "Borra la memoria caché de tu navegador, comprueba la conexión a Internet y vuelve a intentarlo.",
    error_contact: "Contacta con nuestro",
    error_contact_cst: "equipo de Atención al Cliente",
    error_forhelp: "para obtener ayuda.",
    error_having_trouble: "¿Todavía tienes problemas?",
    //Accents and Dialects Dropdowns
    AF: "África",
    AS: "Asia",
    AU: "Australia y Oceanía",
    CA: "Caribe",
    CE: "Centroamérica",
    EU: "Europa",
    MI: "Medio Oriente",
    NO: "Norteamérica",
    SO: "Sudamérica",
    CAMER: "Camerún",
    EGYPT: "Egipto",
    ETHIO: "Etiopía",
    GHANA: "Ghana",
    GUINE: "Guinea",
    NIGER: "Nigeria",
    SOUTH: "Sudáfrica",
    TANZA: "Tanzania",
    AFGHA: "Afganistán",
    CHINA: "China",
    INDIA: "India",
    INDON: "Indonesia",
    JAPAN: "Japón",
    KAZAK: "Kazajistán",
    LEBAN: "Líbano",
    MONGO: "Mongolia",
    NORTH: "Vietnam del Norte",
    PAKIS: "Pakistán",
    PHILI: "Filipinas",
    SINGA: "Singapur",
    KOREA: "Corea",
    SRI_L: "Sri Lanka",
    TAIWA: "Taiwán",
    THAIL: "Tailandia",
    TURKM: "Turkmenistán",
    AUSTR: "Australia",
    FIJI_: "Fiji",
    NEW_Z: "Nueva Zelandia",
    BERMU: "Bermudas",
    CUBA_: "Cuba",
    HAITI: "Haití",
    COSTA: "Costa Rica",
    GUATE: "Guatemala",
    MARTI: "Martinica (francesa)",
    TRINI: "Trinidad y Tobago",
    AUSTRI: "Austria",
    BELAR: "Bielorrusia",
    BELGI: "Bélgica",
    BULGA: "Bulgaria",
    CYPRU: "Chipre",
    CZECH: "República Checa",
    DENMA: "Dinamarca",
    ENGLA: "Inglaterra",
    FINLA: "Finlandia",
    FRANC: "Francia",
    GEORG: "Georgia",
    GERMA: "Alemania",
    GREEC: "Grecia",
    HUNGA: "Hungría",
    IRELA: "Irlanda",
    ITALY: "Italia",
    MACED: "Macedonia del Norte",
    NETHE: "Países Bajos",
    NORTHI: "Irlanda del Norte",
    POLAN: "Polonia",
    ROMAN: "Rumanía",
    RUSSI: "Federación Rusa",
    SCOTL: "Escocia",
    SPAIN: "España",
    SWEDE: "Suecia",
    SWITZ: "Suiza",
    TURKE: "Turquía",
    UKRAI: "Ucrania",
    WALES: "Gales",
    IRAN_: "Irán",
    IRAQ_: "Irak",
    ISRAE: "Israel",
    KUWAI: "Kuwait",
    SAUDI: "Arabia Saudita",
    SYRIA: "Siria",
    CANAD: "Canadá",
    MEXIC: "México",
    ARGEN: "Argentina",
    BRAZI: "Brasil",
    CHILE: "Chile",
    COLOM: "Colombia",
    PARAG: "Paraguay",
    PERU_: "Perú",
    VENEZ: "Venezuela",
    RPTitle: "Rainbow passage",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "Acentos y dialectos ",
    US: "Estados Unidos de América",
    ALABA: "Alabama",
    ALASK: "Alaska",
    ARKAN: "Arkansas",
    CALIF: "California",
    FLORI: "Florida",
    GEORG_US: "Georgia",
    HAWAI: "Hawai",
    ILLIN: "Illinois",
    INDIA_US: "Indiana",
    KANSA: "Kansas",
    KENTU: "Kentucky",
    LOUIS: "Luisiana",
    MAINE: "Maine",
    MARYL: "Maryland",
    MASSA: "Massachusetts",
    MICHI: "Michigan",
    MINNE: "Minnesota",
    MISSI: "Mississippi",
    MISSO: "Missouri",
    MONTA: "Montana",
    NEBRA: "Nebraska",
    NEW_H: "Nuevo Hampshire",
    NEW_J: "Nueva Jersey",
    NEW_Y: "Nueva York",
    NCARO: "Carolina del Norte",
    NDAKO: "Dakota del Norte",
    OHIO_: "Ohio",
    OKLAH: "Oklahoma",
    PENNS: "Pensilvania",
    SOUTH_US: "Carolina del Sur",
    TENNE: "Tennessee",
    TEXAS: "Texas",
    VIRGI: "Virginia",
    WEST_: "Virginia Occidental",
    WISCO: "Wisconsin",
    //Accents and Dialects Dropdowns End
    manager_email_managertext:
      "Tu empresa solicitó un informe mensual sobre tu progreso en Learnship. Indica la dirección de correo electrónico de tu manager.",
    // survey and notification
    notification_description_plural:
      "Quedan {days} días para completar la encuesta. Tendrás que completarla antes del {date}.",
    notification_description_singular:
      "Queda un día para completar la encuesta. Tendrás que completarla antes del {date}.",
    notification_maintenance_message: "Halo estará en mantenimiento programado el {date} a las {time}.",
    //renewal
    renewal_welcome: "¡Hola de nuevo!",
    renewal_text:
      "Tu licencia de Learnship expirará el día {date} de {month} de {year}. Si deseas continuar mejorando tus habilidades de inglés de negocios, no olvides renovar tu licencia hoy mismo. Se guardarán todos tus progresos, así como tu plan de estudios, para que puedas continuar donde lo dejaste.",
    renewal_later: "Recordar más tarde",
    renewal_affirmative: "Deseo renovar mi licencia.",
    renewal_negative: "No deseo renovar mi licencia.",
    renewal_yes: "SÍ",
    renewal_no: "NO",
    courselevel: "Nivel del curso",
    currentunit: "Unidad actual",
    upcomingsession: "Próxima sesión",
    viewschedule: "Ver horario",
    currentskills: "Habilidades",
    currentsubskills: "Sub-habilidades",
    // TWT translations
    twt_talk_with_teacher_title: "Talk with the Teacher",
    twt_sub_heading:
      "Practica tus habilidades de conversación con un profesor y otros compañeros en nuestro salón de clases virtual.",
    twt_select_sessions: "Selecciona tus sesiones",
    twt_view_schedule_title: "Ver horario y añadir al calendario",
    twt_next_week: "Próxima semana",
    twt_previous_week: "Semana anterior",
    twt_add_to_calendar: "Añadir al calendario",
    twt_view_more: "Ver más",
    twt_topic: "Tema",
    twt_class_policy_title: "Normas y directrices de Talk with the Teacher (TWT)",
    twt_class_policy_subHeading:
      "Las siguientes políticas y pautas son importantes para garantizar que tu experiencia con Talk with the Teacher (TWT) sea educativa y agradable. Por favor, lee atentamente.",
    twt_class_policy_list01:
      "Tendrás acceso a una sesión por semana. Nuestro salón de clases virtual tiene un límite de ocho personas por sesión. Eso significa que tendrás que darte prisa y estar disponible antes del comienzo de la sesión para poder acceder al salón de clases virtual. El salón de clases virtual de TWT está disponible solo durante los 10 primeros minutos de cada sesión. Por ejemplo, si una sesión comienza a las 9:00, podrás ingresar hasta las 9:10. Pasados los primeros 10 minutos, no será posible unirse a la sesión.",
    twt_class_policy_list02_sub1:
      "Cuando ingreses al salón de clases virtual, escribe tu nombre, ciudad, país, y nivel en la caja de chat.",
    twt_class_policy_list02_sub2: "Mi nombre es Leo, soy de Sao Paulo, Brasil. Estoy en el nivel 6.",
    twt_class_policy_list02_sub3: "El profesor activará tu micrófono. Entonces aparecerá el icono de micrófono.",
    twt_class_policy_list03:
      "Si tienes un problema técnico, contacta con nuestro equipo de Atención al Cliente. Pulsa en Ayuda en la parte superior de cualquier página. No contactes con tu profesor para pedirle ayuda técnica.",
    twt_class_policy_list04:
      "No te pierdas la orientación de Talk with the Teacher antes de unirte al salón de clases virtual. Esta orientación te proporcionará información útil sobre cómo participar en clases online.",
    twt_class_policy_list05:
      "Hay 4 niveles para las sesiones de Talk with the Teacher (TWT): Principiante, Intermedio, Avanzado y Todos los niveles. Deberás elegir la sesión más apropiada para tus habilidades de idioma. Por ejemplo, si estás en los niveles 0-3, tendrás que acceder a una sesión de Principiante. Cualquier estudiante (en cualquier nivel) puede atender a las sesiones de Todos los niveles. Si accedes a una sesión de TWT que no es la apropiada para tu nivel, el profesor te informará de que no estás en la sesión correcta. Tendrás entonces dos opciones: quedarte a escuchar la sesión sin participar; o abandonar la sesión y unirte a otra sesión de tu nivel.",
    twt_class_policy_list06:
      "Si deseas escuchar una sesión sin participar, podrás hacerlo una hora a la semana. Después de eso, tendrás que participar durante la sesión. Puedes escuchar sin participar un total de cuatro sesiones al año. Si rebasas ese límite, y no participas durante la sesión, se terminará la sesión.",
    twt_class_policy_ok: "Vale",
    twt_max_multi_window_error_message:
      "Ya te uniste a esta sesión desde otro dispositivo. Por favor, cierra la sesión antes de unirte desde el dispositivo actual.",
    twt_max_capacity_error_message:
      "Lo sentimos, no puedes unirte a esta sesión porque ya alcanzó su capacidad máxima. Elige otra sesión para unirte.",
    twt_notification_message: "Hay una sesión de conversación que comienza ahora mismo, ¿quieres unirte?",
    twt_limit_message: "Ya ha tomado una clase esta semana.",
    twt_session_unavailable: "No hay sesiones disponibles",
    twt_select_language: "Select language",
    //Vocabulary center translations
    search:"Buscar y",
    vocab_center_product_headline: "Centro de vocabulario",
    vocab_center_search_word: "Buscar y añadir palabras",
    vocab_center_add_wordlist: "Añadir lista de palabras",
    vocab_center_edit_wordlist: "Editar lista de palabras",
    vocab_center_delete_wordlist: "Eliminar lista de palabras",
    vocab_center_options_text: "Opciones",
    vocab_center_add_word: "Añadir palabra",
    vocab_center_add_text: "Añadir",
    vocab_center_delete_wordlist_warning_message:
      "Se eliminarán todas las palabras de la lista. Pulsa Sí para eliminar.",
    vocab_center_yes_text: "Sí",
    vocab_center_new_wordlist: "Nueva lista de palabras",
    vocab_center_created_wordlist_success_message: "Tu nueva lista de palabras se creó correctamente",
    vocab_center_updated_wordlist_success_message: "Tu lista de palabras se actualizó correctamente",
    vocab_center_okay_text: "Vale",
    vocab_center_new_word_text: "Nueva palabra",
    vocab_center_enter_word_text: "Introducir palabra",
    vocab_center_wordlist_exists: "This wordlist already exists.",
    vocab_center_word_exists_in_wordlist_warning_message: "Esta palabra ya está registrada en tu lista",
    vocab_center_save_text: "Guardar",
    vocab_center_new_word_message: "Esta palabra no la recoge el diccionario, ¿quieres crear tu propia definición?",
    vocab_center_pos_label: "Parte de la oración",
    vocab_center_select_wordlist_text: "Selecciona una lista de palabras",
    vocab_center_word_label: "Palabra",
    vocab_center_update_wordlist: "Actualizar lista de palabras",
    vocab_center_definition_label: "Definición",
    vocab_center_translation_label: "Traducción",
    vocab_center_sentence_label: "Oración",
    vocab_center_note_label: "Nota",
    vocab_center_cancel_text: "Cancelar",
    vocab_center_delete_word_text: "Eliminar palabra",
    vocab_center_delete_word_warning_message: "¿Seguro que deseas eliminar esta palabra de la lista?",
    vocab_center_note_updated_message: "Se actualizaron tus notas correctamente",
    vocab_center_close_text: "Cerrar",
    vocab_center_no_definition_text: "No hay ninguna definición disponible",
    vocab_center_no_translation_text: "No hay ninguna traducción disponible",
    vocab_center_no_sentence_text: "No hay ninguna oración disponible",
    vocab_center_no_note_text: "No se añadieron notas",
    vocab_center_word_save_message: "Se guardó la palabra en tu lista correctamente",
    vocab_center_word_exists_error_message: "La palabra seleccionada ya existe en la lista",
    vocab_center_submit_text: "Enviar",
    vocab_center_delete_text: "Eliminar",
    vocab_center_edit_text: "Editar",
    vocab_center_no_word_message: "¡Vaya! No se encontró ninguna palabra en tu lista. ¡Añade nuevas palabras!",
    vocab_center_no_wordlist_message:
      "¡Vaya! No se encontró ninguna lista de palabras en {wordListName}. ¡Añade una nueva lista!",
    vocab_center_enter_wordlist_text: "Introducir una lista de palabras",
    vocab_center_feature_text: "Sin gramática poco se puede comunicar, sin vocabulario nada – David Wilkins",
    vocab_center_feature_summary:
      "Explora y amplía tu léxico sin esfuerzo con el Centro de Vocabulario, tu puerta de entrada para descubrir y dominar nuevas palabras sin problemas.",
    // Stress and inotation translations
    stress_intonation_product_headline: "Acentuación y entonación",
    stress_intonation_product_description:
      "Haz que tu inglés suene más natural y fácil de entender aprendiendo a utilizar la acentuación, ritmo y entonación correcta cuando hablas.",
    // Sounds of English translations
    soe_product_headline: "Sonidos del inglés",
    soe_product_description:
      "Mejora tus habilidades comunicativas aprendiendo a pronunciar los sonidos del inglés correctamente.",
    soe_product_vowels: "Vocales",
    soe_product_consonants: "Consonantes",
    soe_product_language_selection:
      "Selecciona tu idioma en la lista desplegable y busca los sonidos que pueden resultar más complejos de pronunciar para los hablantes de tu lengua materna. Selecciona “Mis sonidos” para encontrar los sonidos con los que tuviste más problemas en las actividades de pronunciación y comunicación.",
    // Writing center
    wc_feature_headline: "Centro de redacción",
    wc_feature_description: "Mejora tus habilidades de redacción con uno de nuestros recursos.",
    wc_feature_guideGroup1: "Problemas comunes de expresión escrita",
    wc_feature_guideGroup2: "Comunicación de negocios general",
    wc_feature_guideGroup3: "Documentos de negocios",
    wc_feature_guideTitle11: "Razones para una expresión escrita poco precisa",
    wc_feature_guideTitle12: "Errores básicos de expresión escrita",
    wc_feature_guideTitle13: "Problemas con los verbos",
    wc_feature_guideTitle21: "Cómo expresarse de forma directa en las comunicaciones de negocios",
    wc_feature_guideTitle22: "Lenguaje específico para Ventas y Marketing",
    wc_feature_guideTitle23: "Expresiones de negocios cotidianas",
    wc_feature_guideTitle31: "Mensajes de correo electrónico efectivos",
    wc_feature_guideTitle32: "Presentaciones: consejos generales",
    wc_feature_guideTitle33: "Presentaciones: introducciones efectivas",
    // sso leaner intercept
    learners_intercept_title: "ANUNCIO IMPORTANTE",
    learners_intercept_text1:
      "¡La forma de ingresar a Learnship (GlobalEnglish) está cambiando! Citi se ha asociado con Learnship para habilitar un acceso de “Inicio de sesión único o Single Sign On” para todos los estudiantes, a nivel global. A partir del 02:00 CDT del 18 de Noviembre de 2022, deberás ingresar por ",
    learners_intercept_text2:
      "Es muy importante tener en cuenta que a partir de esa fecha no podrás iniciar sesión a través de\u202f",
    learners_intercept_text3: "Toma nota de este cambio y guarda la nueva página como favorita. ",
    learners_intercept_text4:
      "Si requieres asistencia adicional, por favor contacta a tu representante local de RH o a\u202f",
    // google learner intercept
    google_intercept_title: "Important Notice",
    google_intercept_subtitle: "The way you log on to Learnship is changing! ",
    google_intercept_text1: "Google has partnered with Learnship to enable ",
    google_intercept_text2: "for all learners. ",
    google_intercept_text3: "Effective from ",
    google_intercept_text4: "you will be required to go to ",
    google_intercept_text5: "It is important to note that, from ",
    google_intercept_text6: ", you will no longer be able to access your Learnship course through ",
    google_intercept_text7:
      "Please make a note of the above change and remember to delete any old bookmarks and replace it with the new link.",
    google_intercept_text8: "For support, please reach out to ",
    google_sso_text: " Single Sign On (SSO) ",
    google_dd_mmm_text: "18th May",
    google_intercept_time: "10:00am CEST",
    google_intercept_date: "18 May 2023",
    google_intercept_on_text: "on",
    google_link_not_work: "This link will not work before that date.",
    learnship_note_google: "Note: ",
    learnship_family_note_google:
      "This change only applies to Googlers. Family members will continue to log in as before.",
    // nestle learner intercept
    nestle_intercept_title: "Important Notice",
    nestle_intercept_subtitle: "The way you log on to Learnship is changing! ",
    nestle_intercept_text1: "Nestlé has partnered with Learnship to enable ",
    nestle_intercept_text2: "for all learners in Switzerland. ",
    nestle_intercept_text3: "Effective from ",
    nestle_intercept_text4: "you will be required to go to ",
    nestle_intercept_text5: "It is important to note that, from ",
    nestle_intercept_text6: ", you will no longer be able to access your Learnship course through ",
    nestle_intercept_text7:
      "Please make a note of the above change and remember to delete any old bookmarks and replace it with the new link.",
    nestle_intercept_text8: "For support, please reach out to your ",
    nestle_service_desk: "Nestlé ServiceDesk",
    nestle_dd_mmm_text: "4th May",
    nestle_sso_text: " Single Sign On (SSO) ",
    nestle_intercept_time: "10:00am CEST",
    nestle_intercept_date: "4th May 2023",
    nestle_intercept_on_text: "on",
    nestle_intercept_or_text: "or ",
    nestle_link_not_work: "This link will not work before that date.",
    learnship_note_nestle: "Note: ",
    learnship_family_note_nestle:
      "This change only applies to Nestlé employees. Family members will continue to log in as before.",
      welcome_Contact_number_helper_text:'Para garantizar una asistencia rápida y un soporte personalizado, le recomendamos encarecidamente que proporcione también su número de contacto'
  },
};
